import { TokenModel, TokenResponse } from 'app/gamma/src/types';
import genericNormalizer, { normalizeDate } from './generic';

export const normalizeToken = genericNormalizer<TokenResponse, TokenModel>(
  ({ from, has }) => ({
    id: from('id'),
    identifier: from('identifier'),
    permissions: from('permissions'),
    dateCreated: has('dateCreated', normalizeDate),
    dateExpires: has('dateExpires', normalizeDate),
  }),
);
